import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CountdownTimer } from "./CountdownTimer";
import { useOrderFlow } from "../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import moment from "moment";
import { Box, Skeleton } from "@mui/material";
/**
 * A countdown timer that counts down to the cutoff for the selected day
 */
export const CutoffTimer = ({ format = "d:h:m:s", align = "center", className, }) => {
    const { store } = useOrderFlow();
    if (typeof store.cart.cutoffDay === "undefined") {
        return _jsx(Skeleton, { variant: "text", height: 40 });
    }
    const cutoffDay = moment(store.cart.cutoffDay);
    if (moment(cutoffDay, format).isValid()) {
        return (_jsx(Box, Object.assign({ className: className }, { children: _jsx(CountdownTimer, { countdownDate: cutoffDay, format: format, align: align, className: className }) })));
    }
    return _jsx(_Fragment, {});
};
